import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EmissionResume,
  makeEmptyEmissionResume,
} from 'src/models/emission/EmissionResume';

export type EmissionState = {
  emission: EmissionResume;
  isEmissionLoaded: boolean;
};

export const initialState: EmissionState = {
  emission: makeEmptyEmissionResume(),
  isEmissionLoaded: false,
};

const emissionSlice = createSlice({
  name: 'emission',
  initialState,
  reducers: {
    updateEmission: (state, action: PayloadAction<EmissionResume>): void => {
      state.emission = action.payload;
    },
    setEmissionLoaded: (state): void => {
      state.isEmissionLoaded = true;
    },
    setNewVin: (state, action: PayloadAction<string>): void => {
      state.emission.newVinNumber = action.payload;
    },
    setNewInvoiceName: (state, action: PayloadAction<string>): void => {
      state.emission.newInvoiceName = action.payload;
    },
    setNewInvoiceBase64: (state, action: PayloadAction<string>): void => {
      state.emission.newInvoiceBase64 = action.payload;
    },
    resetEmission: (state): void => {
      state.emission = makeEmptyEmissionResume();
      state.isEmissionLoaded = false;
    },
  },
});

export const {
  updateEmission,
  setEmissionLoaded,
  resetEmission,
  setNewVin,
  setNewInvoiceName,
  setNewInvoiceBase64,
} = emissionSlice.actions;

export default emissionSlice.reducer;
